import {
    fetch_repData_Success,
    change_repData,
    clear_store,
    preview_MedicalConclusion_Request,
    fetch_RRHR_QTcAlg_Success,
    change_Lang,
    change_Theme,
    verificate_CmpxIntervals,
    open_modal,
    close_modal,
    fetch_data_Request,
    fetch_data_Failure,
    fetch_data_Success,
    change_selectorGraph,
    change_ReprCmpxGraph,
    change_12Graph,
    change_RhGraph,
    remove_Info,
    remove_InfoGroup,
    add_Info,
    _info_group_SaveData,
    _info_group_ChangeCmpx,
    _info_group_Sign,
    _info_type_success,
    _info_type_error,
    save_data_Request,
    save_data_Failure,
    save_data_Success,
    save_data_prepare,
    change_representativeCmpx_Request,
    change_representativeCmpx_Success,
    change_representativeCmpx_Failure,
    change_SignalFilters,
    sign_Report_Request,
    sign_Report_Failure,
    sign_Report_Success,
    open_modal_withmode,
    change_measurer_ECG12Graph,
    set_stimulator_Request,
    set_stimulator_Failure,
    set_stimulator_Success,
    _info_group_SetStimulator,
    change_wholegraph,
    change_ReportSettings
} from "./actionConstants";

import {
    error_wrong_channel_qty,
    error_cmpxs_lack,
    error_dataapi_url_notset,
    error_session_id_notset,
    error_session_id_closed,
    error_dataapi_request_error,
    error_dataapi_answer_error,
    error_common,
    error_common_markup,
    error_common_user_directory,
    error_common_PDF,
    error_common_wrongIDs,
    error_common_request,
    error_get_data,
    error_get_user_orginfo
} from "../../commonConstants";

import { set_editMode, set_viewMode } from "../reducers/report-reducers/update-edit-mode";

import uuid from "../../utils/uuid";

const fetchRequested = () => ({
    type: fetch_data_Request
});
const fetchSuccessed = () => ({
    type: fetch_data_Success
});
const fetchError = error => ({
    type: fetch_data_Failure,
    payload: error
});

const reportDataLoaded = reportData => ({
    type: fetch_repData_Success,
    payload: reportData
});
const reportDataChanged = reportData => ({
    type: change_repData,
    payload: reportData
});

const changeReportSettings = setts => ({ type: change_ReportSettings, payload: setts });

const previewMedicalConclusion = text => ({ type: preview_MedicalConclusion_Request, payload: text });
const setRRHR_QTcAlg = data => ({ type: fetch_RRHR_QTcAlg_Success, payload: data });

const setEditMode = data => ({ type: set_editMode, payload: data });
const setViewMode = data => ({ type: set_viewMode, payload: data });

const checkError = (data, dispatch) => {
    if (data?.type === "error") {
        const { error_str, error_id } = data;
        let type;

        if (error_str === "EHotboxError.Error_UrlNotSet") {
            type = error_dataapi_url_notset;
        } else if (error_str === "EHotboxError.Error_SessionNotSet") {
            type = error_session_id_notset;
        } else if (error_str === "EHotboxError.Error_SessionClosed") {
            type = error_session_id_closed;
        } else if (error_str === "EHotboxError.Error_RequestError") {
            type = error_dataapi_request_error;
        } else if (error_str === "EHotboxError.Error_AnswerError") {
            type = error_dataapi_answer_error;
        } else if (error_str === "ECommonErrors.Error_GetData") {
            type = error_get_data;
        } else if (
            error_str === "ECommonErrors.Error" ||
            // error_str === "ECommonErrors.Error_Request" ||
            error_str === "ECommonErrors.Error_Exception"
        ) {
            type = error_common;
        } else if (error_str === "ECommonErrors.Error_UserDirectory") {
            type = error_common_user_directory;
        } else if (error_str === "ECommonErrors.Error_MarkupName") {
            type = error_common_markup;
        } else if (
            error_str === "ECommonErrors.Error_PdfPrinterPath" ||
            error_str === "ECommonErrors.Error_PDFProtectedPassword" ||
            error_str === "ECommonErrors.Error_ProcessPDF"
        ) {
            type = error_common_PDF;
        } else if (error_str === "ECommonErrors.Error_WrongIDs") {
            type = error_common_wrongIDs;
        } else if (error_str === "ECommonErrors.Error_Request") {
            type = error_common_request;
        } else if (error_str === "ECommonErrors.Error_GetUserOrgInfo") {
            type = error_get_user_orginfo;
        }

        dispatch(
            fetchError({
                type,
                error_id
            })
        );
        return true;
    }
    return false;
};
let isFetching = false;
const _fetchReportData = async (getReportData, checkData, dispatch, onResIDChangedCallback) => {
    if (isFetching) {
        return;
    }
    isFetching = true;
    dispatch(fetchRequested());
    try {
        // Check
        const checkRes = await checkData();

        // Need redirect ?
        if (!checkRes) throw new Error("Result and data IDs check is faild!");
        else if (checkRes.redirectUrl) {
            onResIDChangedCallback(checkRes);
            return;
        }

        // Check dataservice errors
        if (checkError(checkRes, dispatch)) {
            return;
        }

        // Access rights
        if (checkRes.accessRights === "View") dispatch(setViewMode());
        else if (checkRes.accessRights === "Edit") dispatch(setEditMode());

        // Get data
        let reportData = await getReportData();
        if (checkError(reportData, dispatch)) {
            return;
        }

        // Get base information about ECG_________
        const { report, settings } = reportData;
        dispatch(changeReportSettings(settings));
        delete reportData.report;
        delete reportData.settings;
        reportData = { ...reportData, ...report };

        // Check lead count
        const { chQty, channelNames } = report.signal;
        if (chQty !== 12) {
            dispatch(
                fetchError({
                    type: error_wrong_channel_qty,
                    channelQty: chQty,
                    channelNames
                })
            );
            return;
        }

        // Check complexes
        if (!report.complexes || report.complexes.length === 0) {
            dispatch(
                fetchError({
                    type: error_cmpxs_lack
                })
            );
            return;
        }

        // Reset graphs special settings
        dispatch(changeIntervalSelectorGraphSettings({ desiredCenter_pnt: null }));
        dispatch(changeReprCmpxGraphSettings({ desiredCenter_pnt: null }));

        dispatch(reportDataLoaded(reportData));
        dispatch(fetchSuccessed());
    } catch (error) {
        dispatch(reportDataLoaded(null));
        dispatch(fetchError(error));
    } finally {
        isFetching = false;
    }
};

const fetchReportData = (getReportData, checkData, onResIDChangedCallback) => () => async dispatch => {
    await _fetchReportData(getReportData, checkData, dispatch, onResIDChangedCallback);
};

const fetchPreviewMedConcl = requestPreviewMedicalReport => () => async (dispatch, getState) => {
    try {
        const data = getState().reportApp.app.editState.data;
        const res = await requestPreviewMedicalReport(data);
        if (checkError(res, dispatch)) {
            return;
        }
        if (res.medRepText && typeof res.medRepText === "string") {
            dispatch(previewMedicalConclusion(res.medRepText));
        }
    } catch (error) {
        // dispatch(fetchError(error));
    }
};

const change12LeadGraphSettings = payload => ({ type: change_12Graph, payload });

const isBadVal = val => val === undefined || val === null;
const fetchUpdate_RR_HR_QTc =
    req_RRHR_onInterval =>
    (from_pnt = null, to_pnt = null, reprCmpx_index = null) =>
    async dispatch => {
        if (isBadVal(req_RRHR_onInterval) || isBadVal(from_pnt) || isBadVal(to_pnt) || isBadVal(reprCmpx_index)) return;
        try {
            const res = await req_RRHR_onInterval(from_pnt, to_pnt, reprCmpx_index);
            if (checkError(res, dispatch)) {
                return;
            }

            dispatch(setRRHR_QTcAlg(res));
        } catch (error) {
            // dispatch(fetchError(error));
        }
    };

const fetchPreviewDerivedParams = reqPreviewDerivedParams => (from_pnt, to_pnt, data) => async (dispatch, getState) => {
    try {
        let _data = data;
        if (!_data) {
            // Есть необходимость пересчета зависимых параметров при смене масштаба графика ЭКГ 12 отведений или его позиции
            // для этого запроса надо взять текущие параметры представительного комплекса
            const {
                reportApp: {
                    reportData: {
                        report: { representativeCmpx, signal },
                        settings
                    }
                }
            } = getState();
            const ms_pnt = val => (val === null || val === undefined || isNaN(val) ? null : Math.round((val * signal.fd) / 1000));
            const { Q, S, P, PDur, QTmax, index } = representativeCmpx;
            _data = {
                Q: ms_pnt(Q.val),
                S: ms_pnt(S.val),
                P: ms_pnt(P.val),
                PDur: ms_pnt(PDur.val),
                QT: ms_pnt(QTmax.val),
                QTcAlg: settings.QTcAlg.val,
                ReprCmxIndex: index
            };
        }

        const res = await reqPreviewDerivedParams(_data, from_pnt, to_pnt);
        if (checkError(res, dispatch)) {
            return;
        }

        const { HR_RR, QTcAlg, QTcAvailableAlgs } = res;
        const recalcedParams = {
            HR: HR_RR.HR.val,
            RRmin_ms: HR_RR.RRmin_ms.val,
            RRmax_ms: HR_RR.RRmax_ms.val,
            RRavg_ms: HR_RR.RRavg_ms.val,
            QTcAlg: QTcAlg.val,
            QTcAvailableAlgs
        };

        dispatch(setRRHR_QTcAlg(recalcedParams));
        return res;
    } catch (error) {
        //
    }
};

const changeLang = lang => ({ type: change_Lang, payload: lang });
const verificateCmpx = _value => ({ type: verificate_CmpxIntervals, payload: _value });
const changeTheme = theme => ({ type: change_Theme, payload: theme });

const openModalDialog = _window => {
    return { type: open_modal, payload: _window };
};
const openModalDialogWithMode = data => ({ type: open_modal_withmode, payload: data });
const closeModalDialog = () => ({ type: close_modal });

const changeIntervalSelectorGraphSettings = payload => ({ type: change_selectorGraph, payload });
const changeReprCmpxGraphSettings = payload => ({ type: change_ReprCmpxGraph, payload });
const changeMeasurerECG12GraphSettings = payload => ({ type: change_measurer_ECG12Graph, payload });
const changeRhGraphSettings = payload => ({ type: change_RhGraph, payload });
const changeSignalFilters = payload => ({ type: change_SignalFilters, payload });
const changeWholeGraphSettings = payload => ({ type: change_wholegraph, payload });

const removeInfo = id => ({ type: remove_Info, payload: id });
const removeInfoGroup = group => ({ type: remove_InfoGroup, payload: group });
const addInfo = inf => ({
    type: add_Info,
    payload: inf
});

// Общий код для обработки ошибочного результата от сервера _________________________________
const dispatchFailure = (dispatch, _failure, _info_group, _payload) => {
    dispatch(_failure());
    dispatch(removeInfoGroup(_info_group));
    dispatch(
        addInfo({
            group: _info_group,
            type: _info_type_error,
            payload: _payload,
            id: uuid()
        })
    );
};
const dispatchSuccess = (dispatch, _success_cb, _info_group, _payload) => {
    dispatch(_success_cb());
    dispatch(removeInfoGroup(_info_group));
    dispatch(
        addInfo({
            group: _info_group,
            type: _info_type_success,
            payload: _payload,
            id: uuid()
        })
    );
};

const checkFailureRequestResult = (dispatch, _reqRes, _failure_cb, _info_group, onRedirectCB) => {
    // NEED REDIRECT
    if (onRedirectCB !== undefined && _reqRes.redirectUrl) {
        //window.location.href = _reqRes.redirectUrl;
        onRedirectCB(_reqRes);
        return true;
    }

    // Обработка результата выполнения операции
    if (!_reqRes.error_str) return false; // Ok

    const results = _reqRes.error_str.split(",").map(_s => _s.trim());
    if (results.some(_r => _r.toLowerCase().includes("error") || _r.toLowerCase().includes("unchanged"))) {
        dispatchFailure(dispatch, _failure_cb, _info_group, results);
        return true; // Error
    }
    return false;
};
//__________________________________________________________________________________________
const setRequestState = type => ({ type });

const prepareDataForSave = data => ({ type: save_data_prepare, payload: data });
const clearStore = () => ({ type: clear_store });

const _saveData = async (dispatch, getState, reqSaveData, onRedirectCB) => {
    // Check if it neеd to save data_______
    const {
        app: {
            editState: { needSave, data }
        }
    } = getState().reportApp;

    if (needSave) {
        dispatch(setRequestState(save_data_Request));
        try {
            const reqRes = await reqSaveData(data);
            if (checkFailureRequestResult(dispatch, reqRes, () => setRequestState(save_data_Failure), _info_group_SaveData, onRedirectCB)) {
                const needReload = false;
                return needReload;
            }

            dispatchSuccess(dispatch, () => setRequestState(save_data_Success), _info_group_SaveData); // SUCCES
        } catch (error) {
            dispatchFailure(dispatch, () => setRequestState(save_data_Failure), _info_group_SaveData);
            throw error;
        }
        const needReload = true;
        return needReload;
    }

    const needReload = false;
    return needReload;
};
const saveData = (reqSaveData, getReportData, checkData, onResIDChangedCallback) => () => async (dispatch, getState) => {
    const needReload = await _saveData(dispatch, getState, reqSaveData, onResIDChangedCallback);
    if (needReload) {
        await _fetchReportData(getReportData, checkData, dispatch, onResIDChangedCallback); // Refresh all report data
    }
};

const changeRepresentativeCmpx =
    (requestChangeReprCmpx, getReportData, checkData, onResIDChangedCallback) => data => async (dispatch, getState) => {
        dispatch(setRequestState(change_representativeCmpx_Request));
        try {
            // Send data to save using API
            const reqRes = await requestChangeReprCmpx(data);
            if (
                checkFailureRequestResult(
                    dispatch,
                    reqRes,
                    () => setRequestState(change_representativeCmpx_Failure),
                    _info_group_ChangeCmpx,
                    onResIDChangedCallback
                )
            )
                return;

            await _fetchReportData(getReportData, checkData, dispatch, onResIDChangedCallback); // Refresh all report data
            dispatchSuccess(dispatch, () => setRequestState(change_representativeCmpx_Success), _info_group_ChangeCmpx); // SUCCES
        } catch (error) {
            dispatchFailure(dispatch, () => setRequestState(change_representativeCmpx_Failure), _info_group_ChangeCmpx);
        }
    };

const setStimulator =
    (requestSetStimulator, reqSaveData, getReportData, checkData, onResIDChangedCallback) => data => async (dispatch, getState) => {
        try {
            await _saveData(dispatch, getState, reqSaveData); // Check if it neеd to save data
            dispatch(setRequestState(set_stimulator_Request));
            const reqRes = await requestSetStimulator(data);
            if (
                checkFailureRequestResult(
                    dispatch,
                    reqRes,
                    () => setRequestState(set_stimulator_Failure),
                    _info_group_SetStimulator,
                    onResIDChangedCallback
                )
            )
                return;
            await _fetchReportData(getReportData, checkData, dispatch, onResIDChangedCallback); // Refresh all report data
            dispatchSuccess(dispatch, () => setRequestState(set_stimulator_Success), _info_group_SetStimulator); // SUCCES
        } catch (error) {
            dispatchFailure(dispatch, () => setRequestState(set_stimulator_Failure), _info_group_SetStimulator);
        }
    };

const signReportData = (signReport, reqSaveData, getReportData, checkData, onRedirectCB) => () => async (dispatch, getState) => {
    // Start saving
    try {
        await _saveData(dispatch, getState, reqSaveData); // Check if it neеd to save data
        dispatch(setRequestState(sign_Report_Request));

        // Sign_____
        const reqRes = await signReport();
        if (checkFailureRequestResult(dispatch, reqRes, () => setRequestState(sign_Report_Failure), _info_group_Sign, onRedirectCB))
            // Check failure
            return;

        await _fetchReportData(getReportData, checkData, dispatch, onRedirectCB); // Refresh all report data
        dispatchSuccess(dispatch, () => setRequestState(sign_Report_Success), _info_group_Sign); // SUCCES
    } catch (error) {
        dispatchFailure(dispatch, () => setRequestState(sign_Report_Failure), _info_group_Sign);
    }
};

export {
    reportDataChanged,
    changeReportSettings,
    fetchReportData,
    fetchPreviewMedConcl,
    fetchPreviewDerivedParams,
    changeLang,
    changeTheme,
    verificateCmpx,
    openModalDialog,
    openModalDialogWithMode,
    closeModalDialog,
    changeIntervalSelectorGraphSettings,
    changeReprCmpxGraphSettings,
    change12LeadGraphSettings,
    fetchUpdate_RR_HR_QTc,
    changeMeasurerECG12GraphSettings,
    changeWholeGraphSettings,
    changeRhGraphSettings,
    changeSignalFilters,
    removeInfo,
    prepareDataForSave,
    saveData,
    changeRepresentativeCmpx,
    signReportData,
    clearStore,
    setStimulator,
    setEditMode,
    setViewMode
};
